import React, { Component} from "react";
import { Container, Button, Col, Row } from 'react-bootstrap'
import PoliticaAPP from "./politicaAPP";

const politicaComp = () => {
  return (
    <> 
    <section className="about-container">
        <Container>

          <PoliticaAPP />
        </Container>    
    </section>
    </>
  )
}

export default politicaComp